import axios from 'axios';
const instance = axios.create({});
instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.interceptors.request.use(function (config) {
    config.headers.common['X-CSRF-TOKEN'] = window.token;
    return config;
});
export default instance;
